// src/services/system-update.service.ts
import { supabase }                 from '@/lib/supabase'
import { getCurrentOrganizationId } from '@/helpers/auth.helpers'
import type { SystemUpdateMetadata } from '@/types/teamMessages'

interface PostInput {
  domain:    SystemUpdateMetadata['domain']
  event:     SystemUpdateMetadata['event']
  body:      string
  /** Pass the entity's organization_id to route to the correct org's channel.
   *  Falls back to getCurrentOrganizationId() when omitted. */
  orgId?:    string
  metadata?: Omit<SystemUpdateMetadata, 'domain' | 'event'>
}

export const SystemUpdateService = {
  async post(input: PostInput): Promise<void> {
    try {
      const orgId = input.orgId ?? await getCurrentOrganizationId()
      if (!orgId) return

      const metadata: SystemUpdateMetadata | null = input.metadata
        ? { domain: input.domain, event: input.event, ...input.metadata }
        : null

      const { error } = await supabase.rpc('post_system_update', {
        p_org_id:   orgId,
        p_body:     input.body,
        p_metadata: metadata,
      })

      if (error) {
        console.warn('[SystemUpdateService] post failed:', error.message)
      }
    } catch (err) {
      console.warn('[SystemUpdateService] post threw:', err)
    }
  },
}
